<template>
    <div id="visitorDemo">
        <div class="demo-container">
            <div
                class="demo-header"
                :style="{
                    background: `linear-gradient(0deg,${headerColorFirst},${headerColorSecond})`,
                    color: 'white',
                }"
            >
                <div class="left">
                    <div class="button">
                        <md-icon :style="{ color: 'white' }">chevron_left</md-icon>
                    </div>
                    <div class="avatar">
                        <img src="/static/img/visitorAvatar.png" />
                    </div>
                    <div class="content">
                        <div
                            class="title"
                            :style="{ color: `${headerTextColor}` }"
                        >
                            {{ $t("message.demoVisitorSampleName") }}
                        </div>
                        <div
                            :style="{ color: `${headerTextColor}` }"
                            class="content"
                        >
                            {{ $t("message.demoVisitorSampleSubtitle") }}
                        </div>
                    </div>
                </div>
                <div class="options">
                    <md-icon :style="{ color: 'white' }">more_vert</md-icon>
                </div>
            </div>
            <div
                class="chat-body"
                id="chatBody"
                :style="{
                    background: `linear-gradient(0deg,${backgroundColorFirst},${backgroundColorSecond})`,
                    color: 'white',
                }"
            >
                <div class="representative-message-container">
                    <div
                        :style="{ color: representativeTextColor, backgroundColor: representativeBubbleColor }"
                        class="message-container"
                    >
                        {{ $t("message.demoVisitorSampleAgentMessage") }}
                    </div>
                    <div class="date">{{ $t("message.demoVisitorSampleTime1055") }}</div>
                </div>
                <div class="visitor-message-container first">
                    <div class="date">{{ $t("message.demoVisitorSampleTime1057") }}</div>
                    <div
                        class="message-container"
                        :style="{ color: customerTextColor, backgroundColor: customerBubbleColor }"
                    >
                        {{ $t("message.demoVisitorSampleUserMessage") }}
                    </div>
                </div>
                <div class="visitor-message-container image">
                    <div class="date">{{ $t("message.demoVisitorSampleTime1057") }}</div>
                    <div
                        class="message-container"
                        :style="{ color: customerTextColor, backgroundColor: representativeBubbleColor }"
                    ></div>
                </div>
                <div class="visitor-message-container file">
                    <div class="date">{{ $t("message.demoVisitorSampleTime1057") }}</div>
                    <div
                        class="message-container"
                        :style="{ color: customerTextColor, backgroundColor: customerBubbleColor }"
                    >
                        <DynamicSvg name="PDF" />
                        <div class="text" :style="{ color: customerTextColor }">
                            {{ $t("message.demoVisitorSampleFileName") }}
                        </div>
                        <div class="arrow">
                            <md-icon :style="{ color: customerTextColor }">vertical_align_top</md-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-editor" :style="{ backgroundColor: backgroundColorFirst }">
                <div class="editor-wrapper">
                    <div class="icon-button">
                        <div class="left">
                            <div class="smile-icon">
                                <md-icon> sentiment_satisfied</md-icon>
                            </div>
                            <div class="text" :style="{ color: textColor }">
                                {{ $t("message.demoVisitorSampleInputPlaceholder") }}
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="file-button">
                            <md-icon>attach_file</md-icon>
                        </div>
                        <div class="send-button" :style="{ backgroundColor: buttonColor }">
                            <md-icon :style="{ color: backgroundColorFirst }">send</md-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="triangle">
                    <DynamicSvg name="Triangle" :color="backgroundColorFirst" />
                </div>
                <div class="logo-wrapper">
                    <div class="image-container">
                        <img src="/static/img/poweredSupsis.png" />
                    </div>
                </div>
                <div :style="{ backgroundColor: headerColorFirst }" class="back-button">
                    <md-icon>close</md-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "./common/DynamicSvg.vue";
import { mapState } from "vuex";

export default {
    name: "DemoVisitor",
    components: { DynamicSvg },
    data() {
        return {
            headerColorFirst: { type: String, default: "#EC4B1D" },
            headerColorSecond: { type: String, default: "#EC4B1D" },
            headerTextColor: { type: String, default: "#000" },
            backgroundColorFirst: { type: String, default: "#fbfbfb" },
            backgroundColorSecond: { type: String, default: "#fff" },
            textColor: { type: String, default: "#ffff" },
            errorColor: String,
            formColor: String,
            representativeBubbleColor: {
                type: String,
                default: "#F2F2F2",
            },
            representativeTextColor: {
                type: String,
                default: "#686868",
            },
            customerBubbleColor: {
                type: String,
                default: "#ED5023",
            },
            customerTextColor: {
                type: String,
                default: "#fff",
            },
            buttonColor: {
                type: String,
                default: "#ED5023",
            },
        };
    },
    methods: {
        getColors() {
            const colors = this.settings.chatCustomizationSettings.versionV2Theme.colors;
            this.headerColorFirst = colors.headerColorFirst;
            this.headerColorSecond = colors.headerColorSecond;
            this.headerTextColor = colors.headerTextColor;
            this.backgroundColorFirst = colors.backgroundColorFirst;
            this.backgroundColorSecond = colors.backgroundColorSecond;
            this.textColor = colors.textColor;
            this.representativeTextColor = colors.representativeTextColor;
            this.representativeBubbleColor = colors.representativeBubbleColor;
            this.customerTextColor = colors.customerTextColor;
            this.customerBubbleColor = colors.customerBubbleColor;
            this.buttonColor = colors.buttonColor;
            document.documentElement.style.setProperty("--demoBackgroundForBefore", colors.backgroundColorFirst);
        },
    },
    computed: {
        ...mapState({
            allThemeColors: (state) => state.setting.allThemeColors,
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
        }),
    },
    mounted() {
        const chatBody = document.getElementById("chatBody");
        const chatBodyBefore = chatBody.querySelector("::before");
        this.getColors();
    },
    watch: {
        settings() {
            this.getColors();
        },
    },
};
</script>

<style scoped lang="scss">
:root {
    --demoBackgroundForBefore: #fbfbfb;
}

#visitorDemo {
    width: 100%;
    background-color: transparent;
    height: 100%;

    .demo-container {
        height: 100%;
        padding: 0;
        box-shadow: 0px 18px 8px 3px rgba(0, 0, 0, 0.1);
        border-radius: 10px 10px 0px 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        //border: 1px solid green;

        .demo-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 10px 29px;
            border-radius: 10px 10px 0px 0px;
            //border: 1px solid red;

            .left {
                display: flex;
                align-items: center;

                .button {
                    background-color: rgba(255, 255, 255, 0.31);
                    margin-right: 10px;
                    border-radius: 5px;

                    i {
                        width: 25px;
                        height: 25px;
                    }
                }

                .avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .content {
                    .title {
                    }

                    .content {
                    }
                }
            }

            .options {
            }
        }

        .chat-body {
            position: relative;
            padding: 10px 18px 0px;
            height: calc(100% - 70px);
            //border: 1px solid blue;
            &::before {
                content: "";
                position: absolute;
                top: -22px;
                left: 0;
                width: 100%;
                background-color: var(--demoBackgroundForBefore);
                z-index: -1;
                border-radius: 25px 25px 0px 0px;
                height: 50px;
            }

            .representative-message-container {
                position: relative;
                display: inline-block;

                .message-container {
                    color: rgb(104, 104, 104);
                    border-radius: 5px 15px 15px 15px;
                    padding: 7px;
                    text-align: left;
                    max-width: 239px;
                    display: inline-block;
                    font-size: 12px;
                    font-weight: 500;
                }

                .date {
                    position: absolute;
                    bottom: -4px;
                    right: -30px;
                    font-size: 7px;
                }
            }

            .visitor-message-container {
                position: relative;
                display: flex;
                justify-content: end;
                margin-top: 17px;
                margin-bottom: 17px;

                .message-container {
                    border-radius: 15px 5px 15px 15px;
                    padding: 7px;
                    text-align: right;
                    font-size: 12px;
                    font-weight: 500;
                }

                .date {
                    position: absolute;
                    bottom: -4px;
                    right: 167px;
                    font-size: 7px;
                }

                &.image {
                    position: relative;
                    display: flex;
                    justify-content: end;
                    margin-top: 17px;

                    .message-container {
                        width: 109px;
                        height: 131px;
                    }

                    .date {
                        right: 121px;
                    }
                }

                &.file {
                    position: relative;
                    display: flex;
                    justify-content: end;
                    margin-top: 17px;

                    .message-container {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .icon {
                        }

                        .text {
                            margin: 0px 5px;
                        }

                        .arrow {
                            transform: rotate(180deg);

                            i {
                                font-size: 21px !important;
                            }
                        }
                    }

                    .date {
                        right: 129px;
                        height: 18px;
                    }
                }
            }
        }

        .text-editor {
            width: 100%;
            padding: 17px 0px;
            border-radius: 0px 0px 0px 10px;
            //border: 1px solid yellow;
            .editor-wrapper {
                display: flex;
                justify-content: space-between;
                background-color: white;
                border-radius: 20px;
                padding: 7px;
                width: 90%;
                margin: 0 auto;
                align-items: center;

                .left {
                    display: flex;
                    align-items: center;

                    .smile-icon {
                        margin-right: 5px;
                    }

                    .text {
                    }
                }

                .actions {
                    display: flex;
                    align-items: center;

                    .file-button {
                        i {
                        }
                    }

                    .send-button {
                        margin-right: 5px;
                        border-radius: 50%;
                        overflow: hidden;
                    }

                    i {
                        font-size: 17px !important;
                    }
                }
            }
        }

        .footer {
            width: 100%;
            //border: 1px solid orange;

            .triangle {
                position: absolute;
                bottom: -133px;
                right: 0;
            }

            .logo-wrapper {
                position: absolute;
                bottom: -56px;
                left: 9px;
            }

            .back-button {
                position: absolute;
                bottom: -75px;
                right: 15px;
                padding: 5px;
                border-radius: 50%;

                i {
                    color: white !important;
                }
            }
        }
    }
}
</style>
